var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5901 6.69C18.5933 6.47079 17.6915 5.94144 17.0142 5.17789C16.3369 4.41435 15.9189 3.45587 15.8201 2.44V2H12.3701V15.67C12.3708 16.2766 12.1807 16.868 11.8266 17.3604C11.4725 17.8529 10.9724 18.2215 10.3972 18.414C9.82199 18.6065 9.2008 18.6131 8.62162 18.4329C8.04244 18.2527 7.53464 17.8948 7.17015 17.41C6.84359 16.9808 6.64363 16.4689 6.59287 15.932C6.54212 15.3951 6.64259 14.8548 6.88292 14.372C7.12326 13.8892 7.49388 13.4834 7.95286 13.2003C8.41184 12.9172 8.94088 12.7681 9.48014 12.77C9.77839 12.7683 10.0751 12.8121 10.3601 12.9V9.4C10.0285 9.35893 9.69425 9.34221 9.36015 9.35C8.12946 9.38288 6.93506 9.77393 5.92323 10.4753C4.91139 11.1766 4.12604 12.1578 3.66332 13.2986C3.20061 14.4395 3.08062 15.6905 3.31806 16.8986C3.5555 18.1066 4.14006 19.2191 5.00015 20.1C5.88163 20.9962 7.00964 21.6101 8.24084 21.8638C9.47204 22.1175 10.7509 21.9994 11.9148 21.5246C13.0787 21.0498 14.0753 20.2397 14.7778 19.1973C15.4803 18.1548 15.857 16.9271 15.8601 15.67V8.67C17.2516 9.66395 18.9202 10.1956 20.6301 10.19V6.79C20.2942 6.79139 19.9591 6.75787 19.6301 6.69H19.5901Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.75a073bed90dce23c9ae83e677a6326b.svg";
export { ForwardRef as ReactComponent };